/* eslint-disable import/prefer-default-export */
import React from 'react';

import Table from 'react-bootstrap/Table';

import {
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';

/* FRONTEND_START_MARKER */

export default class UnoWireSensors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sensors: props.UNOWIRE_SENSORS,
            sensorsDetected: [],
            loading: false,
        };
        this.refresh = this.refresh.bind(this);
        this.scan = this.scan.bind(this);
        this.setSerial = this.setSerial.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    setSerial(id, serial) {
        const { sensors } = this.state;
        for (let i = 0; i < sensors.length; i++) {
            if (sensors[i].id === id) {
                this.setState(prevState => ({
                    ...prevState,
                    sensors: prevState.sensors.map(
                        (sensor, j) => (j === i
                            ? { ...sensor, serial }
                            : sensor
                        ),
                    ),
                }));
                break;
            }
        }
    }

    async save() {
        if (this.state.sensors.length === 0) {
            return;
        }
        this.setState({
            loading: true,
        });
        const promises = [];
        const sensors = this.state.sensors;
        for (let i = 0; i < sensors.length; i++) {
            const sensor = sensors[i];
            try {
                promises.push(this
                    .props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.SAVE_UNOWIRE_SENSOR, {
                        f: 'save',
                        id: sensor.id,
                        serial: sensor.serial,
                    }));
            } catch (ex) {
                console.log(ex);
            }
        }
        await Promise.all(promises);
        this.setState({
            loading: false,
        });
    }

    async refresh() {
        this.setState({
            loading: true,
        });
        const { sensors } = this.state;

        let updatedSensors = [
            ...sensors,
        ];
        const responses = [];
        for (let i = 0; i < sensors.length; i++) {
            const sensor = sensors[i];
            try {
                // eslint-disable-next-line no-await-in-loop
                const response = await this.props
                    .runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.GET_UNOWIRE_SENSORS, {
                        f: 'get',
                        id: sensor.id,
                        t: new Date().getTime().toString(),
                    }, 'unowires.html');
                responses.push(response);
            } catch (ex) {
                console.log(ex);
            }
        }
        for (let i = 0; i < responses.length; i++) {
            const data = responses[i];
            updatedSensors = updatedSensors.map(
                (sensor, j) => (j === i
                    ? { ...sensor, serial: data.trim() }
                    : sensor
                ),
            );
        }
        this.setState({
            loading: false,
            sensors: updatedSensors,
        });
    }

    async scan() {
        this.setState({
            loading: true,
            sensorsDetected: [],
        });
        try {
            const data = await this.props
                .runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.SCAN_UNOWIRE_SENSORS, {
                    f: 'scan',
                    ts: new Date().getTime().toString(),
                });
            const lines = data.split('\n');
            const sensorsDetected = [];
            for (let i = 0; i < lines.length; i++) {
                const parts = lines[i].split('\t');
                if (parts.length === 2) {
                    sensorsDetected.push({
                        serial: parts[0],
                        value: parts[1],
                    });
                }
            }
            this.setState({
                loading: false,
                sensorsDetected,
            });
            alert(`${sensorsDetected.length} sensors detected`);
        } catch (ex) {
            this.setState({
                loading: false,
            });
        }
    }

    renderOptions(sensor) {
        const sensors = [
            ...this.state.sensorsDetected,
        ];
        let result = [];
        if (sensor.serial && sensor.serial !== '') {
            result = this.state.sensorsDetected.filter(tmp => tmp.serial === sensor.serial);
        }
        if (sensor.serial !== '' && result.length === 0) {
            sensors.push({
                serial: sensor.serial,
                value: undefined,
            });
        }
        return (
            <select
                className="form-control"
                value={sensor.serial}
                onChange={e => this.setSerial(sensor.id, e.target.value)}
                disabled={this.state.loading}
            >
                <option value="">Unassigned</option>
                {sensors.map((tmpSensor, j) => {
                    return (
                        <option key={j} value={tmpSensor.serial}>
                            {tmpSensor.serial}
                            {tmpSensor.value !== undefined && (
                                `(${tmpSensor.value})`
                            )}
                        </option>
                    );
                })}
            </select>
        );
    }

    render() {
        return (
            <div>
                <h2>1-Wire Sensors</h2>

                <button
                    type="button"
                    className="btn btn-secondary mb-1 me-1"
                    onClick={this.refresh}
                    disabled={this.state.loading}
                >
                    Refresh
                </button>
                <button
                    type="button"
                    className="btn btn-secondary mb-1"
                    onClick={this.scan}
                    disabled={this.state.loading}
                >
                    Scan
                </button>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Sensor Name</th>
                            <th>Tibbit Channel</th>
                            <th>Serial Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.sensors.map((sensor, i) => {
                            return (
                                <tr key={i}>
                                    <td>{sensor.name}</td>
                                    <td>{sensor.channel}</td>
                                    <td>
                                        {this.renderOptions(sensor)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.save}
                    disabled={this.state.loading}
                >
                    Save
                </button>
            </div>
        );
    }
}
